import { observer } from "mobx-react";
import { LastLoginComponent } from "../last-login/last-login.component"
import { InLobbySessionTimerComponent } from "../session-timer/in-lobby/in-lobby-session-timer.component"
import { LastLoginAndSessionTimerBox } from "./boxes/last-login-and-session-timer.box"
import { LastLoginContainerBox } from "./boxes/last-login-container.box";

export const LastLoginAndSessionTimerComponent: React.FC = observer(() => {
    return (
        <LastLoginAndSessionTimerBox>
            <LastLoginContainerBox>
                <LastLoginComponent />
            </LastLoginContainerBox>
            <InLobbySessionTimerComponent />
        </LastLoginAndSessionTimerBox>
    )
});